import { useEffect, useState } from 'react'
import { Box, FormLabel, Stack } from '@chakra-ui/react'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form'

import { CreateButtonWithPermission } from 'components/buttons'
import { CustomForm } from 'components/tools/CustomForm/types'
import { CustomFormScoreClassification } from 'components/tools/CustomForm/types'
import { useCustomFormBuilder } from 'components/tools/CustomForm/components/Builder/contexts/CustomFormBuilderManagerContext/Provider'
import ScoreClassificationIntervalItems from './components/ScoreClassificationIntervalItems'

type Props = {
  setValue: UseFormSetValue<CustomForm>
  watch: UseFormWatch<CustomForm>
}

export default function ScoreClassificationsForm({ watch, setValue }: Props) {
  const [classifications, setClassifications] = useState<CustomFormScoreClassification[]>([])

  const { form } = useCustomFormBuilder()

  const scoreSettings = watch('score_settings')

  function addClassification() {
    setClassifications([...classifications, { tag: '', color: '', condition: 'INTERVAL', to: '0', from: '0' }])
  }

  useEffect(() => {
    const updatedIntervals = { ...scoreSettings }
    if (scoreSettings.classification) updatedIntervals.classification.intervals = classifications
    setValue('score_settings', updatedIntervals)
  }, [classifications])

  useEffect(() => {
    if (form && form.score_settings) setClassifications(form?.score_settings.classification.intervals)
  }, [form])

  return (
    <Box>
      <FormLabel width="max-content" mb={2}>
        Intervalos
      </FormLabel>

      <Stack>
        {classifications.map((classification, index) => (
          <ScoreClassificationIntervalItems
            key={index}
            classifications={classifications}
            classification={classification}
            classificationIndex={index}
            setClassifications={setClassifications}
          />
        ))}
        <CreateButtonWithPermission mt={2} variant="outline" width="100%" onClick={addClassification}>
          Novo intervalo
        </CreateButtonWithPermission>
      </Stack>
    </Box>
  )
}
